module.exports = __webpack_public_path__ + "media/images/users/kotatu-bb2d93fe4aeda62a327fb38d139431cb.png";